import type { ErrorInfo } from 'react';
import { datadogRum } from '@datadog/browser-rum';

const mapRenderError = (error: unknown, errorInfo?: ErrorInfo): Error => {
    const mapped = new Error();
    mapped.name = 'ReactRenderingError';
    mapped.message = error instanceof Error ? error.message : String(error);
    mapped.stack = errorInfo?.componentStack ?? undefined;
    mapped.cause = error;
    return mapped;
};

// Mirrors microwave's ErrorBoundary: render crashes go to Datadog RUM in prod, console otherwise.
export const handleBoundaryError = (error: Error, errorInfo: ErrorInfo): void => {
    const mapped = mapRenderError(error, errorInfo);
    if (import.meta.env.PROD) {
        datadogRum.addError(mapped);
    } else {
        console.error(mapped.message, mapped);
    }
};
